module.exports = __webpack_public_path__ + "static/media/remove.0ac06bf5.svg";